declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

const PIXEL_ID = '1255955049925181'

export function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  const f = window
  const b = document
  const e = 'script'

  const n: any = (f.fbq = function (...args: any[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as any[]

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'

  const s = b.getElementsByTagName(e)[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Plan Antiinflamatorio Después de los 40',
      content_type: 'product',
      value: 6.36,
      currency: 'USD',
    })
  }
}
